
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alertAI-contact",
      function () {
        return require("private-next-pages/alertAI-contact/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alertAI-contact"])
      });
    }
  